import isColor from 'is-color'

export function generateContainerClass(size: number = 12) {
  return {
    'col-span-12': size === 12,
    'lg:col-span-11 col-span-12': size === 11,
    'lg:col-span-10 col-span-12': size === 10,
    'lg:col-span-9 col-span-12': size === 9,
    'lg:col-span-8 col-span-12': size === 8,
    'lg:col-span-7 col-span-12': size === 7,
    'lg:col-span-6 col-span-12': size === 6,
    'lg:col-span-5 col-span-12': size === 5,
    'lg:col-span-4 col-span-12': size === 4,
    'lg:col-span-3 col-span-12': size === 3,
    'lg:col-span-2 col-span-12': size === 2,
    'lg:col-span-1 col-span-12': size === 1,
  }
}

export function generateIconColor(variant?: string | null) {
  const colorClasses = {
    primary: 'text-primary-500 dark:text-gray-400',
    secondary: 'text-secondary-500',
    accent: 'text-accent-500',
    error: 'text-error-500 dark:text-error-400',
    success: 'text-success-500',
    warning: 'text-warning-500',
    info: 'text-info-500',
    link: 'text-link-500',
    default: 'text-gray-400',
    white: 'text-white',
    black: 'text-gray-800',
  }

  if (variant && isColor(variant))
    return { style: { color: variant } }

  return { class: colorClasses[variant as keyof typeof colorClasses] || colorClasses.primary }
}
